// Tickets table ke lambe text (Description, Resolution Notes) ke liye.
//
// WORD_LIMIT (20) shabdon tak: poora text seedha dikhta hai.
// Usse zyada: pehle 20 shabd + "…", aur poora text tooltip me — desktop pe
// hover, mobile pe tap. Tooltip utna hi chauda hai jitna ye column (360px),
// chhoti screen pe screen ke andar simat jaata hai.
//
// Tooltip <body> me banta hai (portal) aur screen ke hisaab se position hota
// hai: table ke dabbe pe overflow: auto hai, to table ke andar bana tooltip
// uske kinare pe kat jaata.
import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import styles from "./RaiseTickets.module.css";

const WORD_LIMIT = 20;
const TOOLTIP_WIDTH = 360;
const EDGE_GAP = 12;

const TicketLongText = ({ text, fallback = "-" }) => {
  const triggerRef = useRef(null);
  const bubbleRef = useRef(null);
  const closeTimer = useRef(null);
  // null = band; warna tooltip ki jagah.
  const [place, setPlace] = useState(null);

  const full = String(text ?? "").trim();
  const words = full ? full.split(/\s+/) : [];
  const isLong = words.length > WORD_LIMIT;

  const open = () => {
    clearTimeout(closeTimer.current);
    const el = triggerRef.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const width = Math.min(TOOLTIP_WIDTH, window.innerWidth - EDGE_GAP * 2);
    const left = Math.min(Math.max(rect.left, EDGE_GAP), window.innerWidth - width - EDGE_GAP);
    // Text ke neeche aur upar kitni jagah bachi hai (8px ka fasla + kinare ka gap
    // chhod kar). Jahan zyada jagah ho wahan kholo, aur tooltip ki unchai usi
    // jagah tak seemit rakho — warna chhoti screen pe wo screen ke neeche se
    // bahar nikal jaata tha aur poora padha nahi jaata tha. Zyada lamba text
    // tooltip ke andar scroll hota hai.
    const spaceBelow = window.innerHeight - rect.bottom - 8 - EDGE_GAP;
    const spaceAbove = rect.top - 8 - EDGE_GAP;
    const above = spaceBelow < 180 && spaceAbove > spaceBelow;
    const maxHeight = Math.max(80, Math.min(above ? spaceAbove : spaceBelow, window.innerHeight * 0.6));
    setPlace(
      above
        ? { left, width, maxHeight, bottom: window.innerHeight - rect.top + 8 }
        : { left, width, maxHeight, top: rect.bottom + 8 },
    );
  };
  const close = () => setPlace(null);
  // Thodi der: mouse text se tooltip tak jaa sake (lamba text scroll karne ke liye).
  const closeSoon = () => {
    clearTimeout(closeTimer.current);
    closeTimer.current = setTimeout(close, 150);
  };

  useEffect(() => () => clearTimeout(closeTimer.current), []);

  // Khula ho to: bahar tap, scroll ya screen ka size badalne par band.
  useEffect(() => {
    if (!place) return undefined;
    const onDown = (e) => {
      if (triggerRef.current?.contains(e.target) || bubbleRef.current?.contains(e.target)) return;
      close();
    };
    const onScroll = (e) => {
      // Tooltip ke apne andar ka scroll use band na kare.
      if (bubbleRef.current?.contains(e.target)) return;
      close();
    };
    document.addEventListener("pointerdown", onDown);
    window.addEventListener("scroll", onScroll, true);
    window.addEventListener("resize", close);
    return () => {
      document.removeEventListener("pointerdown", onDown);
      window.removeEventListener("scroll", onScroll, true);
      window.removeEventListener("resize", close);
    };
  }, [place]);

  if (!full) return fallback;
  if (!isLong) return full;

  return (
    <>
      <span
        ref={triggerRef}
        className={styles.longText}
        tabIndex={0}
        aria-label={full}
        onMouseEnter={open}
        onMouseLeave={closeSoon}
        onFocus={open}
        onBlur={close}
        // Tap hamesha KHOLTA hai (toggle nahi): touch pe browser tap se pehle
        // mouseenter/focus bhi bhejta hai, to toggle karne par tooltip khulte
        // hi band ho jaata. Band: bahar tap, scroll ya mouse hatane se.
        onClick={open}
      >
        {words.slice(0, WORD_LIMIT).join(" ")}…
      </span>
      {place &&
        createPortal(
          <div
            ref={bubbleRef}
            role="tooltip"
            className={styles.longTextBubble}
            style={place}
            onMouseEnter={() => clearTimeout(closeTimer.current)}
            onMouseLeave={closeSoon}
          >
            {full}
          </div>,
          document.body,
        )}
    </>
  );
};

export default TicketLongText;
